<template>
  <div>
    <h5 class="f-s-18 l-h-22 m-b-36 blue-dark">
      Contact Us
    </h5>
    <div class="d-flex">
      <div>
        <p><i class="i-tel" /></p>
        <p><i class="i-e-mail" /></p>
        <p><i class="i-loc-mark" /></p>
      </div>
      <div>
        <p class="f-s-14 grey-1 pl-1 l-s-0_6-p">
          +374 11 666101
        </p>
        <p class="f-s-14 grey-1 pl-1 l-s-0_6-p">
          info@statecs.am
        </p>
        <p class="f-s-14 grey-1 pl-1 l-s-0_6-p">
          Aygedzor St 1st Ln, 2/1,
          <br>
          0019 Yerevan, Armenia
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactUs',
  data() {
    return {
      contactUs: [
        {
          iconClass: 'i-tel',
          label: '+374 11 666101',
        },
        {
          iconClass: 'i-e-mail',
          label: 'info@statecs.am',
        },
        {
          iconClass: 'i-loc-mark',
          label: '23 Street, House 17, 0012, Yerevan, Armenia',
        },
      ],
    };
  },
};
</script>
